import profile_img1 from '../../assets/images/pages/laptop.jpg';
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom'
import { GlobalContext, handleError } from '../../context/Provider';
import { Fragment, useContext, useEffect, useState } from 'react';
import henceforthApi from '../../utils/henceforthApi';
import { numberWithCommas } from '../../utils/validations';
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import moment from 'moment';
import { toast } from 'react-toastify';
import OrderStatus from '../../components/order/OrderStatus';
import henceofrthEnums from '../../utils/henceofrthEnums';
import { INSUFFICIENT_PERMISSIONS } from '../../context/actionTypes';

// TypeScript interfaces
interface SellerProduct {
    order_product_id: string;
    product_id: string;
    prodct_id: string;
    product_name: string;
    product_description: string;
    product_images: string[];
    quantity: number;
    price: number;
    discount_percentage: number;
    discount_price: number;
    actual_product_price: number;
    order_status: string;
    payment_status: string;
    tracking_link: string | null;
    delivery_date: string;
    delivery_type: string;
    reviews: any[];
    created_at: number;
    updated_at: number;
}

interface SellerInfo {
    seller_id: string;
    seller_name: string;
    seller_image?: string;
    seller_phone?: number;
    seller_company?: string;
    seller_address?: string;
    total_price: number;
    seller_earnings: number;
    admin_commission: number;
    tax_amount: number;
    platform_fee: number;
    coupon_discount: number;
    delivery_price: number;
    products: SellerProduct[];
}

interface OrderDetailsNewState {
    order_id: string;
    parent_order_id: string;
    user_info: {
        _id: string;
        profile_pic: string | null;
        name: string;
    };
    address: {
        name: string;
        country_code: string;
        phone_no: number;
        company: string;
        country: string;
        state: string;
        city: string;
        pin_code: string;
        apartment_number: string;
        full_address: string;
        address_type: string;
        lat: string;
        lng: string;
    };
    delivery_type: string;
    sellers: SellerInfo[];
    customer_invoice: {
        invoice_url: string;
        order_id: string;
        subtotal: number;
        coupon_discount: number;
        delivery_charge: number;
        tax_amount: number;
        total_price: number;
        platform_fee: number;
    };
    created_at: number;
    updated_at: number;
}

const OrderDetailsNew = () => {

    const location = useLocation();
    const deliveryType = location.state?.deliveryType || "";
    console.log("deliveryType", deliveryType);

    const match = useMatch(`ordersdetails/:id`);
    const { loading, setLoading, authState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<'order' | 'seller'>('order');
    const [selectedSellerIndex, setSelectedSellerIndex] = useState(0);
    const [state, setstate] = useState({} as OrderDetailsNewState);

    const initialise = async () => {
        try {
            let apiRes = await henceforthApi.Order.orderDetails(match?.params.id);
            setstate(apiRes.data);
        } catch (error: any) {
            if (error?.response?.body?.error === INSUFFICIENT_PERMISSIONS) {
                window.history.back();
            }
        }
    };

    useEffect(() => {
        initialise();
    }, [match?.params.id, authState?.lang]);

    // Calculate totals
    const totalProducts = state?.sellers?.reduce((acc, seller) => acc + (seller.products?.length || 0), 0) || 0;
    const totalSellers = state?.sellers?.length || 0;

    return (
        <>
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="fw-semibold">Order Detail</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/orders/1">Orders</Link></li>
                                    <li className="breadcrumb-item active fw-bold">Order Detail</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <div className='page-spacing'>
                <section className='product-detail'>
                    <div className="container-fluid">
                        {/* Tabs Navigation */}
                        <div className="row mb-4">
                            <div className="col-12">
                                <div className="common-card">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === 'order' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('order')}
                                                type="button"
                                                role="tab"
                                            >
                                                <i className="fa fa-shopping-cart me-2"></i>
                                                Order Overview
                                                <span className="badge ms-2" style={{ backgroundColor: '#1AA7DE' }}>{totalProducts} Products</span>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className={`nav-link ${activeTab === 'seller' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('seller')}
                                                type="button"
                                                role="tab"
                                            >
                                                <i className="fa fa-store me-2"></i>
                                                Sellers
                                                <span className="badge ms-2" style={{ backgroundColor: '#23c6c8' }}>{totalSellers} Sellers</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* Order Tab Content */}
                        {activeTab === 'order' && (
                            <Fragment>
                                {/* Order Summary Cards */}
                                <div className="row gy-3 mb-3">
                                    {/* User Info Card */}
                                    <div className="col-md-6 col-lg-3">
                                        <div className="common-card h-100">
                                            <div className="common-card-title">
                                                <h5><i className="fa fa-user me-2" style={{ color: '#1AA7DE' }}></i>Customer</h5>
                                            </div>
                                            <div className="common-card-content">
                                                <div className="text-center">
                                                    <img
                                                        src={state?.user_info?.profile_pic 
                                                            ? `${henceforthApi.API_FILE_ROOT_MEDIUM}${state.user_info.profile_pic}` 
                                                            : profile_placeholder}
                                                        alt={state?.user_info?.name}
                                                        className="rounded-circle mb-2"
                                                        width="80"
                                                        height="80"
                                                    />
                                                    <h6 className="fw-bold mb-1">{state?.user_info?.name || 'N/A'}</h6>
                                                    {(deliveryType == "DELIVERY" && state?.address?.phone_no && <p className="text-muted small mb-0">
                                                        <i className="fa fa-phone me-1"></i>
                                                        {`+${state.address.country_code}-${state.address.phone_no}`}
                                                    </p>)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Products Count Card */}
                                    <div className="col-md-6 col-lg-3">
                                        <div className="common-card h-100">
                                            <div className="common-card-title">
                                                <h5><i className="fa fa-box me-2" style={{ color: '#1AA7DE' }}></i>Products</h5>
                                            </div>
                                            <div className="common-card-content">
                                                <div className="text-center">
                                                    <h2 className="fw-bold mb-0" style={{ color: '#1AA7DE' }}>{totalProducts}</h2>
                                                    <p className="text-muted small mb-0">Total Items Ordered</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Sellers Count Card */}
                                    <div className="col-md-6 col-lg-3">
                                        <div className="common-card h-100">
                                            <div className="common-card-title">
                                                <h5><i className="fa fa-store me-2" style={{ color: '#23c6c8' }}></i>Sellers</h5>
                                            </div>
                                            <div className="common-card-content">
                                                <div className="text-center">
                                                    <h2 className="fw-bold mb-0" style={{ color: '#23c6c8' }}>{totalSellers}</h2>
                                                    <p className="text-muted small mb-0">Different Sellers</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Order Status & Type Card */}
                                    <div className="col-md-6 col-lg-3">
                                        <div className="common-card h-100">
                                            <div className="common-card-title">
                                                <h5><i className="fa fa-info-circle me-2" style={{ color: '#23c6c8' }}></i>Order Info</h5>
                                            </div>
                                            <div className="common-card-content">
                                                <div className="text-center">
                                                    {state?.sellers?.[0]?.products?.[0] && (
                                                        <OrderStatus {...state.sellers[0].products[0]} />
                                                    )}
                                                    <p className="text-muted small mt-2 mb-0">
                                                        <i className="fa fa-truck me-1"></i>
                                                        <strong>{state?.delivery_type && 'N/A'}</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Customer Invoice Section */}
                                <div className="row gy-3 mb-3">
                                    <div className="col-12">
                                        <div className="common-card">
                                            <div className="common-card-title d-flex justify-content-between align-items-center">
                                                <h5><i className="fa fa-file-invoice me-2"></i>Customer Invoice</h5>
                                                {state?.customer_invoice?.invoice_url && (
                                                    <a 
                                                        href={state.customer_invoice.invoice_url} 
                                                        className="btn btn-sm btn-primary"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ backgroundColor: '#1AA7DE', borderColor: '#1AA7DE' }}
                                                    >
                                                        <i className="fa fa-download me-1"></i>Download Invoice
                                                    </a>
                                                )}
                                            </div>
                                            <div className="common-card-content">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>Order ID</th>
                                                                <th>Subtotal</th>
                                                                <th>Delivery Charge</th>
                                                                {/* <th>Coupon Discount</th> */}
                                                                <th>Tax Amount</th>
                                                                <th>Platform Fee</th>
                                                                <th>Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td><strong>{state?.customer_invoice?.order_id || 'N/A'}</strong></td>
                                                                <td>&#8377;{numberWithCommas(state?.customer_invoice?.subtotal || 0)}</td>
                                                                <td>&#8377;{numberWithCommas(state?.customer_invoice?.delivery_charge || 0)}</td>
                                                                {/* <td>&#8377;{numberWithCommas(state?.customer_invoice?.coupon_discount || 0)}</td> */}
                                                                <td>&#8377;{numberWithCommas(state?.customer_invoice?.tax_amount || 0)}</td>
                                                                <td>&#8377;{numberWithCommas(state?.customer_invoice?.platform_fee || 0)}</td>
                                                                
                                                                <td className="fw-bold" style={{ color: '#23c6c8' }}>&#8377;{numberWithCommas(state?.customer_invoice?.total_price || 0)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Delivery Address - Hide for PICKUP */}
                                {deliveryType !== 'PICKUP' && (
                                    <div className="row gy-3 mb-3">
                                        <div className="col-md-6">
                                            <div className="common-card h-100">
                                                <div className="common-card-title">
                                                    <h5><i className="fa fa-map-marker-alt me-2" style={{ color: '#ed5565' }}></i>Delivery Address</h5>
                                                </div>
                                                <div className="common-card-content">
                                                    <address className="mb-0">
                                                        <strong>{state?.address?.name || 'N/A'}</strong><br />
                                                        {state?.address?.full_address || 'N/A'}<br />
                                                        {state?.address?.city}, {state?.address?.state} - {state?.address?.pin_code}<br />
                                                        {state?.address?.country}<br />
                                                        <i className="fa fa-phone me-1"></i> {state?.address?.phone_no || 'N/A'}<br />
                                                        <span className="badge" style={{ backgroundColor: '#1AA7DE' }}>{state?.address?.address_type || 'N/A'}</span>
                                                    </address>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Order Timeline */}
                                        <div className="col-md-6">
                                            <div className="common-card h-100">
                                                <div className="common-card-title">
                                                    <h5><i className="fa fa-clock me-2" style={{ color: '#1AA7DE' }}></i>Order Timeline</h5>
                                                </div>
                                                <div className="common-card-content">
                                                    <ul className="list-unstyled mb-0">
                                                        <li className="mb-2">
                                                            <i className="fa fa-calendar-check me-2" style={{ color: '#23c6c8' }}></i>
                                                            <strong>Ordered:</strong> {state?.created_at ? moment(state.created_at).format('DD MMM YYYY, hh:mm A') : 'N/A'}
                                                        </li>
                                                        <li className="mb-2">
                                                            <i className="fa fa-calendar-update me-2" style={{ color: '#1AA7DE' }}></i>
                                                            <strong>Updated:</strong> {state?.updated_at ? moment(state.updated_at).format('DD MMM YYYY, hh:mm A') : 'N/A'}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Fragment>
                        )}

                        {/* Seller Tab Content */}
                        {activeTab === 'seller' && (
                            <Fragment>
                                {/* Seller Selection Tabs (if multiple sellers) */}
                                {totalSellers > 1 && (
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <div className="common-card">
                                                <div className="common-card-title">
                                                    <h5>Select Seller</h5>
                                                </div>
                                                <div className="common-card-content">
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {state?.sellers?.map((seller, index) => (
                                                            <button
                                                                key={seller.seller_id}
                                                                className={`btn ${selectedSellerIndex === index ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                onClick={() => setSelectedSellerIndex(index)}
                                                                style={selectedSellerIndex === index ? { backgroundColor: '#1AA7DE', borderColor: '#1AA7DE' } : {}}
                                                            >
                                                                <i className="fa fa-store me-1"></i>
                                                                {seller.seller_name} ({seller.products?.length || 0} products)
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Selected Seller Details */}
                                {state?.sellers && state.sellers[selectedSellerIndex] && (
                                    <Fragment>
                                        {/* Seller Info & Financial Summary */}
                                        <div className="row gy-3 mb-3">
                                            <div className="col-md-4">
                                                <div className="common-card h-100">
                                                    <div className="common-card-title">
                                                        <h5><i className="fa fa-user-tie me-2"></i>Seller Details</h5>
                                                    </div>
                                                    <div className="common-card-content">
                                                        <div className="text-center mb-3">
                                                            <img
                                                                src={state.sellers[selectedSellerIndex].seller_image
                                                                    ? `${henceforthApi.API_FILE_ROOT_MEDIUM}${state.sellers[selectedSellerIndex].seller_image}`
                                                                    : profile_placeholder}
                                                                alt={state.sellers[selectedSellerIndex].seller_name}
                                                                className="rounded-circle mb-2"
                                                                width="100"
                                                                height="100"
                                                            />
                                                            <h5 className="fw-bold mb-1">{state.sellers[selectedSellerIndex].seller_name}</h5>
                                                            <p className="text-muted small mb-0">{state.sellers[selectedSellerIndex].seller_company || 'N/A'}</p>
                                                        </div>
                                                        <hr />
                                                        <ul className="list-unstyled mb-0">
                                                            <li className="mb-2">
                                                                <i className="fa fa-phone me-2 text-primary"></i>
                                                                {state.sellers[selectedSellerIndex].seller_phone || 'N/A'}
                                                            </li>
                                                            <li className="mb-2">
                                                                <i className="fa fa-map-marker-alt me-2 text-danger"></i>
                                                                {state.sellers[selectedSellerIndex].seller_address || 'N/A'}
                                                            </li>
                                                            <li>
                                                                <Link to={`/seller/${state.sellers[selectedSellerIndex].seller_id}`} className="btn btn-sm btn-primary w-100" style={{ backgroundColor: '#1AA7DE', borderColor: '#1AA7DE' }}>
                                                                    <i className="fa fa-eye me-1"></i>View Profile
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Seller Price Breakdown */}
                                            <div className="col-md-8">
                                                <div className="common-card h-100">
                                                    <div className="common-card-title d-flex justify-content-between align-items-center">
                                                        <h5><i className="fa fa-calculator me-2"></i>Price Breakdown</h5>
                                                        {(state?.sellers[selectedSellerIndex]?.products?.[0]?.order_status === henceofrthEnums.OrderStatus.CONFIRMED || 
                                                          state?.sellers[selectedSellerIndex]?.products?.[0]?.order_status === henceofrthEnums.OrderStatus.DELIVERED) && (
                                                            <Link 
                                                                to={`/invoice/${state.parent_order_id}/${state.sellers[selectedSellerIndex].products[0].order_product_id}/SELLER`} 
                                                                className="btn btn-sm btn-primary"
                                                                target="_blank"
                                                                style={{ backgroundColor: '#1AA7DE', borderColor: '#1AA7DE' }}
                                                            >
                                                                <i className="fa fa-download me-1"></i>Download Invoice
                                                            </Link>
                                                        )}
                                                    </div>
                                                    <div className="common-card-content">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Description</th>
                                                                        <th>Amount (&#8377;)</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Total Product Price</td>
                                                                        <td>$ {numberWithCommas(state.sellers[selectedSellerIndex].total_price || 0)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Delivery Charge</td>
                                                                        <td>$ {numberWithCommas(state.sellers[selectedSellerIndex].delivery_price || 0)}</td>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td>Coupon Discount</td>
                                                                        <td className="text-danger">- &#8377;{numberWithCommas(state.sellers[selectedSellerIndex].coupon_discount || 0)}</td>
                                                                    </tr> */}
                                                                    <tr>
                                                                        <td>Tax Amount</td>
                                                                        <td>$ {numberWithCommas(state.sellers[selectedSellerIndex].tax_amount || 0)}</td>
                                                                    </tr>

                                                                    <tr style={{ backgroundColor: '#e8f8f5' }}>
                                                                        <td><strong>Seller Earnings</strong></td>
                                                                        <td><strong style={{ color: '#23c6c8' }}>$ {numberWithCommas(state.sellers[selectedSellerIndex].seller_earnings || 0)}</strong></td>
                                                                    </tr>

                                                                    <tr style={{ backgroundColor: '#f9f9f9' }}>
                                                                        <td><strong>Platform Fee</strong></td>
                                                                        <td><strong style={{ color: '#ed5565' }}>$ {numberWithCommas(state.customer_invoice.platform_fee || 0)}</strong></td>
                                                                    </tr>
                                                                    <tr style={{ backgroundColor: '#f9f9f9' }}>
                                                                        <td><strong>Admin Commission</strong></td>
                                                                        <td><strong style={{ color: '#ed5565' }}>$ {numberWithCommas(state.sellers[selectedSellerIndex].admin_commission || 0)}</strong></td>
                                                                    </tr>
                                                                    
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Seller Products Table */}
                                        <div className="row gy-3 mb-3">
                                            <div className="col-12">
                                                <div className="common-card">
                                                    <div className="common-card-title">
                                                        <h5><i className="fa fa-box me-2"></i>Products from {state.sellers[selectedSellerIndex].seller_name}</h5>
                                                    </div>
                                                    <div className="common-card-content">
                                                        <div className="table-responsive">
                                                            <table className="table table-striped align-middle">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>Image</th>
                                                                        <th>Product Name</th>
                                                                        <th>Product ID</th>
                                                                        <th>Qty</th>
                                                                        <th>Price</th>
                                                                        <th>Discount</th>
                                                                        <th>Final Price</th>
                                                                        <th>Status</th>
                                                                        <th>Delivery Date</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {state.sellers[selectedSellerIndex].products?.map((product, index) => (
                                                                        <tr key={product.order_product_id}>
                                                                            <td>{index + 1}</td>
                                                                            <td>
                                                                                {product.product_images?.[0] ? (
                                                                                    <img 
                                                                                        src={henceforthApi.FILES.imageSmall(product.product_images[0])} 
                                                                                        alt={product.product_name}
                                                                                        className="rounded"
                                                                                        width="50"
                                                                                        height="50"
                                                                                    />
                                                                                ) : (
                                                                                    <img 
                                                                                        src={profile_placeholder} 
                                                                                        alt="placeholder"
                                                                                        className="rounded"
                                                                                        width="50"
                                                                                        height="50"
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                            <td>
                                                                                <Link to={`/product/${product.product_id}`}>
                                                                                    <strong>{product.product_name}</strong>
                                                                                </Link>
                                                                            </td>
                                                                            <td><small>{product.prodct_id}</small></td>
                                                                            <td>{product.quantity}</td>
                                                                            <td>&#8377;{numberWithCommas(product.price)}</td>
                                                                            <td>
                                                                                <span className="badge" style={{ backgroundColor: '#f8ac59', color: '#fff' }}>
                                                                                    {product.discount_percentage}% OFF
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <strong>&#8377;{numberWithCommas(product.discount_price)}</strong>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`badge ${
                                                                                    product.order_status === 'DELIVERED' ? 'bg-success' : 
                                                                                    product.order_status === 'CANCELLED' ? 'bg-danger' : 
                                                                                    'bg-warning'
                                                                                }`} style={{
                                                                                    backgroundColor: product.order_status === 'DELIVERED' ? '#23c6c8' : 
                                                                                                     product.order_status === 'CANCELLED' ? '#ed5565' : 
                                                                                                     '#f8ac59'
                                                                                }}>
                                                                                    {product.order_status}
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                {product.delivery_date 
                                                                                    ? moment(Number(product.delivery_date)).format('DD MMM YYYY') 
                                                                                    : 'N/A'}
                                                                            </td>
                                                                            <td>
                                                                                <Link to={`/product/${product.product_id}`} className="btn btn-sm btn-primary" style={{ backgroundColor: '#1AA7DE', borderColor: '#1AA7DE' }}>
                                                                                    <i className="fa fa-eye me-1"></i>View
                                                                                </Link>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                            </Fragment>
                        )}
                    </div>
                </section>
            </div>
        </>
    );
};

export default OrderDetailsNew;
